import { createContext } from 'react';

export type TTypeOfModalWindow = null | 'cropper';
export type TTypeOfErrorModalWindow =
	| null
	| 'imgFileSizeExceeded'
	| 'gifFileSizeExceeded'
	| 'fileUploadError'
	| 'invalidImageFormat'
	| 'invalidGifFormat';

export interface IStyleSettingsImageUploaderState {
	isLoading: boolean;
	uploaderSrc: string | null;
	cropperSrc: string | null;
	typeOfModalWindow: TTypeOfModalWindow;
	typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	loadingImageError: boolean;
	isNewImageUploaded: boolean;
}

export const styleSettingsImageUploaderInitialState: IStyleSettingsImageUploaderState = {
	isLoading: false,
	uploaderSrc: null,
	cropperSrc: null,
	typeOfModalWindow: null,
	typeOfErrorModalWindow: null,
	loadingImageError: false,
	isNewImageUploaded: false,
};

export interface IStyleSettingsImageUploaderContext extends IStyleSettingsImageUploaderState {
	setLoading(value: boolean): void;
	setUploaderSrc(src: string | null): void;
	setCropperSrc(src: string | null): void;
	uploadImage(value: Blob): Promise<string | undefined>;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeTypeOfErrorModalWindow(value: TTypeOfErrorModalWindow): void;
	setLoadingImageError(value: boolean): void;
	setNewImageUploaded(value: boolean): void;
}

export const StyleSettingsImageUploaderContext = createContext<IStyleSettingsImageUploaderContext>({
	setLoading: () => undefined,
	setUploaderSrc: () => undefined,
	setCropperSrc: () => undefined,
	uploadImage: async () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeTypeOfErrorModalWindow: () => undefined,
	setLoadingImageError: () => undefined,
	setNewImageUploaded: () => undefined,
	...styleSettingsImageUploaderInitialState,
});
